module.exports = __webpack_public_path__ + "img/zhAward-5.c4eea1b5.png";